import React, { useContext } from 'react'
import {
  COLORS,
  BUTTON_SIZE,
  STUDENT_PROGRESS_STATUS,
  PANELS,
} from '@helpers/constants'
import Button from '@components/Button'
import { evaluateBookProgress } from '@helpers/exams'
import { AppContext } from '@state/context'
import {
  setSelectedBookForProgressInspection,
  setSelectedInspectionStatus,
  setSelectedSchoolResourceForProgressInspection,
  setSelectedSectionForProgressInspection,
} from '@state/actions/appActions'
import { openPanel } from '@state/actions/panelsActions'

const BookProgressButtons = (props) => {
  const { book, resource } = props
  const { sections } = book

  const [state, dispatch] = useContext(AppContext)

  // if (!book) return null

  const bookProgress = evaluateBookProgress(sections, resource?.students)

  const openProgressInspectionPanel = (status) => {
    dispatch(setSelectedInspectionStatus(status))
    dispatch(setSelectedSchoolResourceForProgressInspection(resource))

    dispatch(setSelectedSectionForProgressInspection(null))
    dispatch(setSelectedBookForProgressInspection(book))

    dispatch(openPanel(PANELS.INSPECT_PROGRESS))
  }

  return (
    <div className='flex items-center justify-between gap-4'>
      <ProgressButton
        icon='SectionCircleNoAttempts'
        count={bookProgress?.notStartedCount}
        status={STUDENT_PROGRESS_STATUS.NOT_STARTED}
        handleClick={() => {
          openProgressInspectionPanel(STUDENT_PROGRESS_STATUS.NOT_STARTED)
        }}
      />
      <ProgressButton
        icon='SectionCircleHasAttempts'
        count={bookProgress?.inProgressCount}
        status={STUDENT_PROGRESS_STATUS.IN_PROGRESS}
        handleClick={() => {
          openProgressInspectionPanel(STUDENT_PROGRESS_STATUS.IN_PROGRESS)
        }}
      />
      <ProgressButton
        icon='SectionCircleFailedCross'
        count={bookProgress?.anyFailedCount}
        status={STUDENT_PROGRESS_STATUS.FAILED}
        handleClick={() => {
          openProgressInspectionPanel(STUDENT_PROGRESS_STATUS.FAILED)
        }}
      />
      <ProgressButton
        icon='SectionCirclePassedCheckmark'
        count={bookProgress?.allPassedCount}
        status={STUDENT_PROGRESS_STATUS.PASSED}
        handleClick={() => {
          openProgressInspectionPanel(STUDENT_PROGRESS_STATUS.PASSED)
        }}
      />
    </div>
  )
}

const ProgressButton = ({ icon, count, handleClick }) => (
  <Button
    size={BUTTON_SIZE.NO_PADDING}
    textColor={COLORS.WHITE.TEXT}
    icon={icon}
    iconLeft
    handleClick={handleClick}
  >
    {count !== undefined ? count.toString() : '-'}
  </Button>
)

export default BookProgressButtons
